import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router';
import { LazyMotion, domAnimation, MotionConfig } from 'motion/react';
import { routes } from './routes';
import './styles/index.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root not found');

const router = createBrowserRouter(routes);

createRoot(container).render(
  <StrictMode>
    {/* Charge le sous-ensemble « domAnimation » de motion (plus léger que le
        pack complet) une seule fois pour toute l'application. */}
    <LazyMotion features={domAnimation} strict>
      {/* Respecte le réglage « réduire les animations » du système (confort,
          mal des transports, batterie) : les mouvements sont neutralisés. */}
      <MotionConfig reducedMotion="user">
        <RouterProvider router={router} />
      </MotionConfig>
    </LazyMotion>
  </StrictMode>,
);
